const env = process.env
const tenantCode = 'tenant_whfm' // 租户码 tenant_whfm tenant_cy
const APP_TYPE = env.VUE_APP_KEY // storage key 前缀（注意唯一性，不可与其他web相同）
const softPort = env.VUE_APP_INTERANET_PORT // 做实验的服务器端口号（用于软件登录）
const path = env.VUE_APP_PUBLICK_PATH
// 5.12外网版本
const intranetIp = env.VUE_APP_INTERANET_HOST
const networkProtocol = env.VUE_APP_N_P // 网络协议
const baseIp = env.VUE_APP_API_HOST // API服务器IP
const baseServer = `${baseIp}`

// https://lab.fmaster.cn
const baseUrl = `${networkProtocol}://${baseServer}`

// wss://lab.fmaster.cn
const wsUrl = networkProtocol === 'https' ?
    `wss://${baseServer}` :
    `ws://${baseServer}`

// https://lab.fmaster.cn/res
const staticUrl = `${baseUrl}/res` // 静态资源服务器URL

module.exports = {
    tenantCode,
    intranetIp,
    softPort,
    baseServer,
    baseUrl,
    wsUrl,
    staticUrl,
    env,
    APP_TYPE,
    path
}
